import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { CountdownDialogComponent } from "./countdown-dialog.component";
import { CountdownDialogService } from "./countdown-dialog.service";


@NgModule({
    imports: [
        CommonModule,
        FlexLayoutModule,
        MatButtonModule,
        MatDialogModule,
        MatProgressBarModule,
    ],

    declarations: [CountdownDialogComponent],
    exports: [CountdownDialogComponent],
    providers: [CountdownDialogService],
})
export class CountdownDialogModule {}